const muiCustomStyles = {

  leftBox: {
    flex: 1,
    backgroundColor: "rgba(231, 246, 238, 1)",
    position: "relative",
    overflow: "hidden",
    height: { xs: "100%", sm: "auto" },
    borderRadius: { xs: "12px", sm: "0px" },
  },

  leftInnerBox: {
    m: "24px",
  },

  leftTextWrapper: {
    zIndex: 99,
    position: "relative",
    maxWidth: "430px",
    margin: "auto",
  },

  leftHeading: {
    fontSize: { xs: "32px", sm: "41px" },
    fontWeight: 700,
    lineHeight: "130%",
    maxWidth: "350px",
  },

  leftSubText: {
    mt: { xs: "16px", sm: "24px" },
    fontSize: "15px",
    fontWeight: 600,
    zIndex: 99,
  },

  bannerBox: {
    position: { xs: "relative", sm: "absolute" },
    bottom: 0,
    left: 0,
    width: "100%",
    height: "170px",
    maxHeight: "170px",
    backgroundImage: "url('/images/hello-spring-banner.png')",
    backgroundSize: "cover",
    backgroundPosition: "center",
    backgroundRepeat: "no-repeat",
  },

  rightBox: {
    flex: 1,
    overflow: "hidden",
    display: "flex",
    flexDirection: "column",
    backgroundColor: { xs: "rgba(255, 255, 255, 1)", sm: "transparent" },
    height: { xs: "100%", sm: "auto" },
    borderRadius: { xs: "12px", sm: "0px" },
  },

  rightScrollBox: {
    flex: 1,
    m: "24px",
    mr: "12px",
    pr: "12px",
    overflow: "auto",
    maxHeight: "100%",
    minHeight: 0,
    display: { xs: "flex", sm: "block" },
    alignItems: "center",
    scrollbarWidth: "thin",
    "&::-webkit-scrollbar": {
      display: "block",
    },
  },

  rightTextWrapper: {
    zIndex: 99,
    position: "relative",
    maxWidth: "430px",
    margin: "auto",
  },

  rightHeadingWrapper: {
    mb: { xs: "24px", sm: "32px" },
    display: "flex",
    flexDirection: "column",
    gap: { xs: "12px", sm: "16px" },
  },

  rightHeading: {
    fontSize: "18px",
    fontWeight: 600,
    lineHeight: "28px",
  },

  rightHeading2: {
    fontSize: "16px",
    fontWeight: 600,
    lineHeight: "28px",
  },

  rightParagraph: {
    fontSize: "15px",
    fontWeight: 400,
    lineHeight: "160%",
    mb: "16px",
  },

  rightParagraphLast: {
    fontSize: "15px",
    fontWeight: 400,
    lineHeight: "160%",
    mb: "32px",
  },

  helpTitle: {
    fontSize: "18px",
    fontWeight: 600,
    lineHeight: "28px",
    mb: { xs: "16px", sm: "8px" },
  },

  helpSubText: {
    fontSize: "15px",
    fontWeight: 400,
    lineHeight: "28px",
    mb: { xs: "8px", sm: "0px" },
  },

  iconButtonWrapper: {
    display: "flex",
    ml: "-8px",
  },

  buttonWrapper: {
    display: "flex",
    justifyContent: "flex-end",
    width: "100%",
    p: "24px",
    pt: "0px",
    backgroundColor: "rgba(255, 255, 255, 1)",
    zIndex: 99,
  },

  gotItButton: {
    backgroundColor: "rgba(37, 124, 109, 1)",
    color: "white",
    fontSize: 15,
    fontWeight: 500,
    textTransform: "none",
    borderRadius: "8px",
    paddingX: "16px",
    height: "39px",
    "&:hover": { backgroundColor: "rgba(31, 106, 90, 1)" },
  },

  updateImage: {
    width: { xs: "50px", sm: "100px" },
    height: { xs: "50px", sm: "100px" },
    borderRadius: "6px",
    border: "1px solid rgba(234, 234, 234, 1)",
    flexShrink: 0,
  },

  smallScreenHeading: {
    fontSize: "18px",
    fontWeight: 500,
    lineHeight: "38px",
    mb: "16px",
  },
};

export default muiCustomStyles;
